<script setup>
import {ref} from "vue";
import ToneOfVoiceGuideModal from "@/components/content/modals/ToneOfVoiceGuideModal.vue";

const openModal = ref(false);
</script>

<template>
  <button
    class="btn function-btn"
    @click="openModal = true"
  >
    Tone of Voice Guide
  </button>

  <ToneOfVoiceGuideModal
    v-if="openModal"
    @close="openModal = false"
  />
</template>
